import React from 'react';

export default function PageLoader({ label = 'Loading page…' }) {
  return (
    <div role="status" className="flex items-center justify-center gap-3 p-8">
      <span className="spinner" aria-hidden="true" />
      <span>{label}</span>
    </div>
  );
}

export class PageErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return (
        <div role="alert" className="card p-6 space-y-4">
          <h1 className="text-title">This page could not load</h1>
          <p>Check your connection, then reload this page. Your saved data is unchanged.</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="btn-primary btn-md"
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
